<template>
  <ValidationProvider
    v-slot="{ errors }"
    :name="`field_${_uid}`"
    :rules="rules"
    mode="eager"
    slim
  >
    <v-select
      v-model="fieldValue"
      clearable
      outlined
      flat
      hide-details="auto"
      bottom
      :label="fieldLabel"
      :name="fieldLabel"
      :items="options"
      :error-messages="errors"
      :menu-props="{ bottom: true, offsetY: true }"
      v-bind="$attrs"
    />
  </ValidationProvider>
</template>

<script>
import { extend, ValidationProvider } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import i18n from '@/i18n';

extend('required', {
  ...required,
  message: i18n.t('validation.fieldIsMandatory')
});

export default {
  props: {
    item: {
      type: Object,
      required: true
    },

    value: {
      type: String,
      required: false,
      default: ''
    }
  },

  computed: {
    options() {
      return [
        { text: this.$t('application.yesNoAnswer.1'), value: 'true' },
        { text: this.$t('application.yesNoAnswer.0'), value: 'false' }
      ];
    },

    fieldLabel() {
      let label = this.localize(this.item.label);

      // TODO: use enumeration
      if (this.item.fieldValidationMode === 2) {
        label += '*';
      }

      return label;
    },

    fieldValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    },

    rules() {
      if (this.item.fieldValidationMode === 2) {
        return 'required';
      }

      return '';
    }
  },

  components: {
    ValidationProvider
  }
};
</script>
